<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">
            {{
              (msg || "").toLowerCase().includes("pending")
                ? "Confirm Pending?"
                : "Submit for Approval?"
            }}
          </div>

          <div class="delete-description">
            {{ msg }}
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="setLoading"
            @click="no()"
          >
            No
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            class="btn-save"
            :loading="setLoading"
            :disabled="setLoading"
            @click="yes()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import icon from "@/assets/icon.vue";
export default {
  props: {
    msg: null,
  },
  components: { icon },
  data() {
    return {
      dialog: false,
      setLoading: false,
    };
  },
  watch: {
    msg: {
      handler(data) {
        if (data) {
          this.dialog = true;
        } else {
          this.dialog = false;
          this.setLoading = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    yes() {
      this.setLoading = true;
      this.$emit("yes");
    },

    no() {
      this.setLoading = false;
      this.dialog = false;
      this.$emit("no");
    },
  },
};
</script>
